document.addEventListener("DOMContentLoaded", function () {
  /**
   * BUILD YOUR OWN TRAVEL SET
   * ------------------------------------------------------------
   * This script controls:
   * - opening and closing the fragrance selector modal
   * - searching fragrances
   * - saving 3 selected fragrance names into line-item properties
   * - calculating the final travel set price
   * - switching the real Shopify variant so cart/checkout price is correct
   * - updating the visible product price on the product page
   */

  /**
   * Main custom builder wrapper and modal.
   * If either is missing, stop the script so it does not affect other products.
   */
  const builder = document.querySelector("[data-travel-builder]");
  const modal = document.querySelector("[data-travel-modal]");

  if (!builder || !modal) return;

  /**
   * Find the actual Shopify product form containing this travel builder.
   * This prevents accidentally updating another product/payment form.
   */
  const productForm = builder.closest('form[action*="/cart/add"]');

  if (!productForm) return;

  /**
   * Variant data printed from Liquid.
   * Each variant should include:
   * id, title, option1, price, available
   */
  const variantsElement = document.querySelector(
    "[data-travel-variants]"
  );

  let variants = [];

  try {
    variants = JSON.parse(
      variantsElement?.textContent || "[]"
    );
  } catch (error) {
    console.error(
      "Travel-set variant data could not be parsed:",
      error
    );
  }

  /**
   * Currency symbol comes from Liquid through data-currency-symbol.
   * Example: ₹
   */
  const currencySymbol =
    builder.dataset.currencySymbol || "";

  /**
   * Stores customer selections by slot number.
   *
   * Example:
   * selected.get("1") = {
   *   title: "Fragrance Name",
   *   collection: "Chapter I",
   *   price: 50000
   * }
   */
  const selected = new Map();

  /**
   * Remembers which of the 3 fragrance slots is currently being edited.
   */
  let activeSlot = null;

  /**
   * Shopify/theme elements within the correct product form.
   *
   * variantInput:
   * The hidden variant ID submitted to Shopify.
   *
   * addButton:
   * Disabled until all 3 fragrances are selected
   * and a matching Shopify variant exists.
   */
  const variantInput = productForm.querySelector(
    'input[name="id"]'
  );

  const addButton = productForm.querySelector(
    'button[name="add"]'
  );

  /**
   * Custom UI elements inside the travel builder.
   */
  const totalText = builder.querySelector(
    "[data-travel-total]"
  );

  const totalInput = builder.querySelector(
    "[data-travel-total-input]"
  );

  const errorText = builder.querySelector(
    "[data-travel-error]"
  );

  const searchInput = modal.querySelector(
    "[data-travel-search]"
  );

  const closeButton = modal.querySelector(
    "[data-travel-close]"
  );

  /**
   * Converts Shopify minor-unit prices into readable money.
   *
   * Examples:
   * 50000 becomes ₹500
   * 150000 becomes ₹1,500
   */
  function money(value) {
    const numericValue = Number(value) || 0;

    return `${currencySymbol}${(
      numericValue / 100
    ).toLocaleString("en-IN")}`;
  }

  /**
   * Calculates the total price from all selected fragrance slots.
   */
  function total() {
    return Array.from(selected.values()).reduce(
      function (sum, item) {
        return sum + item.price;
      },
      0
    );
  }

  /**
   * Updates the visible Shopify variant picker option.
   *
   * This helps the theme behave as though the customer manually
   * selected the matching price variant.
   *
   * Supports:
   * - radio-button variant pickers
   * - dropdown/select variant pickers
   */
  function updateSelectedVariantOption(optionValue) {
    if (!optionValue) return;

    const escapedValue =
      typeof CSS !== "undefined" && CSS.escape
        ? CSS.escape(optionValue)
        : optionValue.replace(/"/g, '\\"');

    /**
     * First try a radio-style variant picker.
     */
    const radioInput = productForm.querySelector(
      `input[type="radio"][value="${escapedValue}"]`
    );

    if (radioInput) {
      radioInput.checked = true;

      radioInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );

      return;
    }

    /**
     * Then try a dropdown-style variant picker.
     */
    const selectOption = productForm.querySelector(
      `option[value="${escapedValue}"]`
    );

    if (
      selectOption &&
      selectOption.parentElement
    ) {
      selectOption.parentElement.value =
        optionValue;

      selectOption.parentElement.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }
  }

  /**
   * Updates the visible price block on the product page.
   *
   * This changes only the displayed product-page price.
   * The actual cart/checkout price comes from the submitted variant ID.
   */
  function updateProductPriceDisplay(finalTotal) {
    const formattedPrice = money(finalTotal);

    const priceTargets =
      document.querySelectorAll(
        ".price-item--regular, " +
          ".price-item--sale, " +
          ".price__regular .price-item, " +
          ".price__sale .price-item"
      );

    priceTargets.forEach(function (priceTarget) {
      priceTarget.textContent =
        formattedPrice;
    });
  }

  /**
   * Main price and variant-sync function.
   *
   * It:
   * 1. Calculates the selected fragrance total.
   * 2. Finds an available Shopify variant with that exact price.
   * 3. Updates the real variant ID submitted to Shopify.
   * 4. Updates the visible product-page price.
   * 5. Enables Add to Cart only when the setup is valid.
   */
  function updateVariant() {
    const calculatedTotal = total();

    /**
     * Before any selection, display the minimum price ₹1,500.
     * After selection begins, display the calculated total.
     */
    const finalTotal =
      selected.size === 0
        ? 150000
        : calculatedTotal;

    /**
     * Find an available Shopify variant with the exact calculated price.
     *
     * The Shopify product should contain variants priced for every
     * possible combination, such as:
     * ₹1,500, ₹1,600, ₹1,700 and ₹1,800.
     */
    const matchingVariant = variants.find(
      function (variant) {
        return (
          Number(variant.price) ===
            Number(finalTotal) &&
          variant.available
        );
      }
    );

    /**
     * Update the custom total display.
     */
    if (totalText) {
      totalText.textContent =
        money(finalTotal);
    }

    /**
     * Keep Travel Set Total only if this hidden property input
     * still exists in the Liquid.
     */
    if (totalInput) {
      totalInput.value =
        money(finalTotal);
    }

    /**
     * Update the actual Shopify variant.
     */
    if (matchingVariant) {
      updateSelectedVariantOption(
        matchingVariant.option1
      );

      if (variantInput) {
        const matchingVariantId = String(
          matchingVariant.id
        );

        /**
         * Update both the live property and HTML value attribute.
         */
        variantInput.disabled = false;
        variantInput.value = matchingVariantId;

        variantInput.setAttribute(
          "value",
          matchingVariantId
        );

        variantInput.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
      }
    }

    /**
     * Update the product-page display price.
     */
    updateProductPriceDisplay(finalTotal);

    /**
     * Enable Add to Cart only when:
     * - exactly 3 fragrances have been selected
     * - a matching available Shopify variant was found
     */
    if (addButton) {
      addButton.disabled =
        selected.size !== 3 ||
        !matchingVariant;
    }

    /**
     * Show the helper error after a partial selection.
     */
    if (errorText) {
      errorText.hidden =
        selected.size === 0 ||
        selected.size === 3;
    }
  }

  /**
   * Opens the fragrance selector modal for a particular slot.
   */
  function openModal(slot) {
    activeSlot = slot;

    modal.classList.add("is-active");

    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    if (searchInput) {
      searchInput.value = "";

      filterList("");

      searchInput.focus();
    }
  }

  /**
   * Closes the fragrance selector modal.
   */
  function closeModal() {
    modal.classList.remove("is-active");

    modal.setAttribute(
      "aria-hidden",
      "true"
    );
  }

  /**
   * Filters the fragrance list while the customer types.
   *
   * Search checks:
   * - fragrance title
   * - collection title
   */
  function filterList(query) {
    const search = String(query || "")
      .trim()
      .toLowerCase();

    const items = modal.querySelectorAll(
      "[data-fragrance-item]"
    );

    items.forEach(function (item) {
      const searchableText = (
        item.dataset.searchText ||
        item.textContent ||
        ""
      ).toLowerCase();

      const isMatch =
        searchableText.includes(search);

      item.style.display =
        isMatch ? "" : "none";
    });
  }

  /**
   * Slot buttons.
   * The customer clicks one of the three slots to select
   * or replace a fragrance.
   */
  builder
    .querySelectorAll(
      "[data-open-travel-modal]"
    )
    .forEach(function (button) {
      button.addEventListener(
        "click",
        function () {
          openModal(
            this.dataset.openTravelModal
          );
        }
      );
    });

  /**
   * Fragrance selection.
   *
   * Duplicate fragrance selections are allowed.
   */
  modal
    .querySelectorAll(
      "[data-fragrance-item]"
    )
    .forEach(function (item) {
      item.addEventListener(
        "click",
        function () {
          if (!activeSlot) return;

          // Prevent sold-out fragrances from being selected
          if (item.dataset.available !== "true") return;

          /**
           * Build the selected fragrance object
           * using Liquid data attributes.
           */
          const fragrance = {
            title:
              item.dataset.perfumeTitle || "",

            collection:
              item.dataset.collectionTitle ||
              "",

            price:
              Number(item.dataset.price) || 0
          };

          /**
           * Save the fragrance against the selected slot.
           */
          selected.set(
            activeSlot,
            fragrance
          );

          /**
           * Update visible fragrance name.
           */
          const slotLabel =
            builder.querySelector(
              `[data-slot-label="${activeSlot}"]`
            );

          if (slotLabel) {
            slotLabel.textContent =
              fragrance.title;
          }

          /**
           * Update visible fragrance price.
           */
          const slotPrice =
            builder.querySelector(
              `[data-slot-price="${activeSlot}"]`
            );

          if (slotPrice) {
            slotPrice.textContent =
              money(fragrance.price);
          }

          /**
           * Update the Shopify line-item property.
           *
           * Only the fragrance name is submitted:
           *
           * Fragrance 1: Selected name
           * Fragrance 2: Selected name
           * Fragrance 3: Selected name
           */
          const fragranceInput =
            builder.querySelector(
              `[data-slot-input="${activeSlot}"]`
            );

          if (fragranceInput) {
            fragranceInput.value =
              fragrance.title;
          }

          /**
           * Mark the slot as selected for styling.
           */
          const slotTrigger =
            builder.querySelector(
              `[data-open-travel-modal="${activeSlot}"]`
            );

          if (slotTrigger) {
            slotTrigger.classList.add(
              "is-selected"
            );
          }

          /**
           * Close the modal and sync price/variant.
           */
          closeModal();

          updateVariant();
        }
      );
    });

  /**
   * Live fragrance search.
   */
  if (searchInput) {
    searchInput.addEventListener(
      "input",
      function () {
        filterList(this.value);
      }
    );
  }

  /**
   * Close-modal button.
   */
  if (closeButton) {
    closeButton.addEventListener(
      "click",
      closeModal
    );
  }

  /**
   * Clicking the modal backdrop closes it.
   */
  modal.addEventListener(
    "click",
    function (event) {
      if (event.target === modal) {
        closeModal();
      }
    }
  );

  /**
   * Initial setup.
   *
   * Shows the minimum price and disables Add to Cart
   * until all three fragrances are selected.
   */
  updateVariant();
});